module.exports = function() {
  return new Worker(__webpack_public_path__ + "97989a92a24648604685.worker.js");
};